import React from "react";
import * as Tooltip from "@radix-ui/react-tooltip";

function PowerButton() {
  return (
    <Tooltip.Provider>
      <Tooltip.Root delayDuration={0}>
        <Tooltip.Trigger asChild>
          <div className="relative">
            {/* Power button container - lights up white on hover */}
            <div
              className="w-8 h-8 rounded-full border-2 border-zinc-700/60 group-hover:border-white/80 bg-zinc-900/90 flex items-center justify-center shadow-lg transition-all duration-300"
              style={{
                boxShadow:
                  "inset 0 2px 3px rgba(0, 0, 0, 0.6), 0 1px 2px rgba(0, 0, 0, 0.5)",
              }}
            >
              {/* Power icon symbol - lights up white on hover */}
              <svg
                className="w-4 h-4 text-zinc-600 group-hover:text-white/80 transition-colors duration-300"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <line
                  x1="12"
                  y1="4"
                  x2="12"
                  y2="10"
                  strokeLinecap="round"
                  strokeWidth={2.5}
                />
                <path
                  d="M8 6.5C6 8 5 10 5 12.5c0 3.9 3.1 7 7 7s7-3.1 7-7c0-2.5-1-4.5-3-6"
                  strokeLinecap="round"
                  strokeWidth={2}
                />
              </svg>
              {/* white glow effect on hover */}
              <div
                className="absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                style={{
                  boxShadow:
                    "0 0 6px rgba(255, 255, 255, 0.3), inset 0 0 6px rgba(255, 255, 255, 0.15)",
                }}
              />
            </div>
          </div>
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content
            side="bottom"
            className="z-50 max-w-xs rounded-md bg-black px-3 py-2 text-xs text-white shadow-md"
          >
            Instance can be stopped and started. Data persists until the
            instance is deleted. Storage fees apply when stopped.
            <Tooltip.Arrow className="fill-black" />
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
}

export default PowerButton;
